import api from '../lib/axios';
import type { ApiResponse } from '@maios/shared';

export interface ImpactAnalysisResponse {
  issue: { issueId: string; issueKey: string; title: string; updatedAt: string };
  impacts: {
    designItems: {
      designItemId: string; title: string; status: string;
      needsReReview: boolean; assignee?: { userId: string; name: string };
    }[];
    tasks: { issueId: string; issueKey: string; title: string; statusId: string; hasOpenPR: boolean }[];
    pullRequests: { prId: string; prNumber: number; title: string; state: string }[];
    testCases: { testCaseId: string; title: string; lastResult: string }[];
  };
  summary: {
    totalDesignItems: number; designNeedsReReview: number;
    totalTasks: number; totalPRs: number; totalTests: number;
  };
}

export interface TraceabilityResponse {
  designItem: { designItemId: string; title: string; status: string };
  linkedIssues: {
    issueId: string; issueKey: string; title: string; statusId: string; linkType: string;
    pullRequests: { prId: string; prNumber: number; title: string; state: string }[];
    testCases: { testCaseId: string; title: string; lastResult: string }[];
  }[];
}

export async function fetchImpactAnalysis(projectId: string, issueId: string): Promise<ImpactAnalysisResponse> {
  const res = await api.get<ApiResponse<ImpactAnalysisResponse>>(
    `/projects/${projectId}/issues/${issueId}/impact-analysis`,
  );
  return res.data.data!;
}

export async function fetchTraceability(projectId: string, designItemId: string): Promise<TraceabilityResponse> {
  const res = await api.get<ApiResponse<TraceabilityResponse>>(
    `/projects/${projectId}/design-items/${designItemId}/traceability`,
  );
  return res.data.data!;
}

export async function dismissReReviewFlag(projectId: string, designItemId: string, note?: string): Promise<unknown> {
  const res = await api.delete<ApiResponse<unknown>>(
    `/projects/${projectId}/design-items/${designItemId}/re-review-flag`,
    { data: { note } },
  );
  return res.data.data!;
}
